var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.esHeader)?_c('span',[_c('span',[_c('b',[_vm._v(_vm._s(_vm.tituloHeader)+":")]),_vm._v("\n    "+_vm._s(_vm.getFullNameByType(
        _vm.nombre,
        _vm.apellidos,
        _vm.razonSocial,
        _vm.isCompany(_vm.tipoUsuario)
      )))])]):_c('div',[(_vm.isCompany(_vm.tipoUsuario))?_c('div',[_c('p',[_c('b',[_vm._v(_vm._s(_vm.$t("common.razonSocial"))+":")]),_vm._v("\n      "+_vm._s(_vm.getFullNameByType(
          _vm.nombre,
          _vm.apellidos,
          _vm.razonSocial,
          _vm.isCompany(_vm.tipoUsuario)
        ))+"\n    ")])]):_c('div',[_c('p',[_c('b',[_vm._v(_vm._s(_vm.$t("common.nombreCompleto"))+":")]),_vm._v("\n      "+_vm._s(_vm.getFullNameByType(
          _vm.nombre,
          _vm.apellidos,
          _vm.razonSocial,
          _vm.isCompany(_vm.tipoUsuario)
        ))+"\n    ")])])])}
var staticRenderFns = []

export { render, staticRenderFns }